const envWhitelist = process.env.NEXT_PUBLIC_PARTNER_WHITELIST
  ? process.env.NEXT_PUBLIC_PARTNER_WHITELIST.split(',')
  : []

export const PARTNER_WHITELIST = [
  ...envWhitelist,
  '5x2Ab8jhkRZ2qU145sEwER78usUdubTS6RvdGfsHQaNR', // Mes
  '7pPJt2xoEoPy8x8Hf2D6U6oLfNa5uKmHHRwkENVoaxmA', // milimalism
  '2wUw8YSdPR8xt2UB5mkNaAvoLRFEbueAHVtfraTMSVw9', // @Donmarvey1212
  'Arm6pG2ev83MbokXZQEFD7qCKDvVWtYpEkqmCfbxcpRh', // Nuel
  'DJCh1SEmRuzodXP4zbMtEzGXA6zcdrctS2JZ1rbG8sLa', // @SonOfTesmod
  'HSCYLhNcgBuzLjERPS8BDpCzL3GNwaaPeqgQeecHEfWK', // imcudz
  '3zxtSkehQA7Dtknwkt95FMnp4h4MDWYHM1epj9xeRsof', // The lazy sol
  'EUisgNmineB4u1WA8K1UDCZMGdXjuPjwGQuZq3RtLq1d', // Utkash
  '5YLUmcpRKyY1YQESMTFiwoA8moTGcjSLadoRC9PxgC5P', // futarkey
  '7R7mMA8Vk5fkviPZCSZ1x8KqDzmVGD4J4bBwtqkZiasK', // dak_didi
  'EUisgNmineB4u1WA8K1UDCZMGdXjuPjwGQuZq3RtLq1d', // @0xShuk
  'CsdiJuKP7mFwq8HNQg5rcQHzZYS6HPjCNMJvdim1vi3K', // rikbit
  '8P1H18JwVxdXGGyuUCKinfkU8z3FJVBpWHToJd4868Cm', // rakikavun
  '3PKhzE9wuEkGPHHu2sNCvG86xNtDJduAcyBPXpE6cSNt', // itsafact
  'DVjB4DuBZtpmEJMN2bqKP9xmeMaMCQyuTYSU3yvhoqZD', // pajameez
  '9LP9sDXt7S1VBCXYPi7vphVXhRhwMup1f7W2FkATMD5a', // georgescopito
  'Cw8P1eBBUoTNeqrzB5bk7GkmkR3QfdTP511UUVrum6Js', // UltorDeFi
  '222MwWpgU6gKquYFyqKMJdmcXmXMEBNBhuXffHgkAbyd', // eric.spindler
  'FJtuv651745TdCQx1F6mxwR8jgHUcxTs4HTDPEFVjaQu', // @Jfreelance123
  '5R3oMErv9C3qdXGXdnp3vURiHctxCmJPvTHN18AQHtbY', // @deathrealtor25
  'GJdRQcsyz49FMM4LvPqpaM2QA3yWFr8WamJ95hkwCBAh', // @Aon_chain
  'D6SKfqPdaRiNH9HnwEhQR6EhtKgSwxe1LAj1YbGH482o', // NoNameGems
  '8KCfTN6Yeq12EJnRmsh4gmoi2EcyV9v3iizjoCXGttnK', // https://x.com/gyyzyt123
  'H47NzDSrY2whJ7Uni7NqxxYTjqoPztPNa5NPRdwLcxTF', //sprab12
  'F16H2KJzn2LnVd9mGukK5L4dGdRGnU7Njk1SWGLPNAvL', //@CQ_Elzz
  'Q4xxgxC1Aza78FzkGQw3p8NU4b4NcgNKmbbSc7WKzYC', //MaxMaxEdits_
  'HnMk9i2pzzJ77Udr8HNjiZASiYJka1wMWehF2Jhfgep6', //Ruggedking01
  'H7KdTWBV45Lww7zBm8DJ5hhMpaWbEQdsNC84HQe47BaS', //@tanqiwei23
  '5RRzt5impbDhzGepEZj44JqTu7o6NmXNRKSM4rSQPX1z', // @Pubgocto
  '4dVUrpj9cXPdPuVtwxmLcUjDvXNM89ioLtmFk2NqySK6', //@marcuslayerx
  'DNM2BcF4W8FcyNjJ5JkGdA8xR4rHU5bnnBsHpcnRfr8A', //HabardGlar
  'AGQQ7hQxFKMJM13bDLZPURRhs49n44DDqqvYqHiWH5H3', //Kram3334
  '8FvCwsZPqBtuTjhg9sy2vrLEtmRUscqg2dg9QzFvyCDR', //kiddaking11
  'EVr7pnPaNrmiiaB1oXckJ6EaX7cJvZEYovGtDQy6jffa', //naidrcrypto
  'BAsYVqMSeXU7sbPoZwdjm1x92Kg84UF9H6234hFybeaS', // DawisuX
  '6Sfxt17i1tNvK176GfrkeWTaHCWXDsrZh5kv3232bxVa', //@realjr333
  'VgENRfKTL2gdj8Vxtv6LuAqHvWYEFn555mMNah1DLco', //blessedgohd
  '62q5UyJCBDrPPwnaFW1kSruQdFQnrGqvDPMR1A8Ko1qF', //the_saint_mas
  'FoVPC9zcLpQUtCHw525oAboyFMiSrAV8WH6pqdFZN6k1', //cryptonerd48
  '6o9QYGSYDViG6V2nsgnZ2wvM7mcyiMPnX5xxTHk5t9mm', //Fletcherolisaex
  '7ni5AQMZN86x8CReKFmycVM1Uy9TCMpJmQ7rsRhCZ7in', //Kryptonuub
  'EJhcrno3PWgvZpwVjkcsETQFRNehcNfvLtSUnmbLwd2h', //pxlxbt
  'DcpHAc2EnfEwaZ4RPaSTcmdKzmjnuPXrsg8b3nwD7SfH', //MarchicaCrypto
  'BNyA3XdfyD4Qrzmziw7RTYRHK5raHMVgBdJwBfjzKoDJ', //blessiano4luv
  'AKHzU65Pr9afpMAzByLfAjRusUNW2nM7khCdt4cG8qH4', //0xCabana
  'futEr6crxky587rKdqa8pVraFgEQCwadaYg3sPmxWNA', //10krotator
  '7Fxu9vH7AdFaeNsxKstx4CV1G6SHQDzrPp6YAHjSoCpf', //rjeasy01
  '7Dn6hv1k9XNtcDbXeZSpXiP87TwbwBLWvYZsP4NCGv2T', //CryptactWeb3
  'DjWbX4pLruGtjng7Ub8zo7ZuNiL7Jwz4CYsiuwcHPnPZ', //@Bazzo__
  '9GEnZozGAWSTH18creSwZNbaUTdyLMBpdHH99sPrjhBt', //CryptoMania_123
  'HQrw4r7GvxhYQrnfJodNYfLMYA9Cqeaf49vKvGJwWFf3', // Manuel660487
  '8yviDusaoDCPyEPYg9ALKBsPoZD5ZSBvbYtmoyZZo6VP', //cptdegenerate
  '6QB68efkwymc64jCpXqp9k7KNH5GHW2jr8oRxCj7t1P7', //Mirandacai4
  'FusEdpCiQKVQyEcu7E7BivG9FvSQF4WFPzmDi4ZMRpgZ', //krzysm_00
  'DXip8KZcHuMXf9MUywGFn8XSNndDFFGGhofxxceBQhWD', //Usertwohundret1
  'BiRqMDpwEGiLYB4hNB8xZjWnHaL81oo8KctaWqGzS1LH', //varocoin1
  'FgAipsKbVKkyytiVkSQkgJ8VCqZL9ynrijG4Tg9aTNrz', //nervenote
  '8sQSKzZ6yjzXjkEXgxpBw5E2Q8BNnT5urriXPhz3559c', //Darkman_crypto
  '99yYpqjeSavMFfY1gQy3ruaep5JSkcKS3u4Yvzg1AiWm', //MrDiamondBags
  'H4SKbByDUq6v8HTdkZEZ46EVL4f1LUeJ6gBAczMqcqAq', //SoltanZewar
  '7NKSPdB79u7973UVbeSWuyeShbV9CBoMaQ1UCDR2N4XN', //@engineered_shot
  '3WVq9rdYcp4Ngu1afjxRc41zcoU3aLrbyqB4HUNnviNL', //CryptoLaith
  '4C4GN39hD82qcTwLqBsQdMfpkp9hSYEymQrridv844qD', //max3embaru
  'B1R5FcP6RNGtBTEk7iXnhwW1BCgCZUfyJ4CUbrYxxCam', //@ram_trw
  '27sD5JQmwkgnFYxJhd288sXsC3W9zZdp9vPCCuLdAv7A', //trozilnikabal
  'BaGZs1kiqrqeW5yEDMymPFK3Jz9tQ8NwtMaiXRTdjWMn', //@2112ets
  '4hcKvjU4EMzz5TSjgk7CMwhTwy4gXTuhdEYHyd5Shaz8', //@We_Are_YouChain
  'JC9Zjrp9xVa4HqcX9D711fpG257EL6cVy9CHcUwSeNq9', //crypto996601
  '8N26jjwebH3TncfHzeNzqWeFfxk5FBxN9jcaKSzQhuve', //0xRauzas
  'AoERs7SzMVuRKmzwugp6uN21M9BPGk3hJDi2KpnxDSvP', //TROYSTON1990
  'J3dktnVyFgR1s6Ux9fJW8TbebmWV12YvvYkhgWR5c7X4', //Teaona X
  'H9jSCQVLUnMv4c99MZQKJ3Be52W4TTHGcGRLkr8kRfko', //Oxvictorr
  'AVp36MrZghfdTe3aNesywnzQuBK3Q5cHFcDkpYMd9Pan', //0x_tyG
  'A5Tqs3fgCk9JVpx29hF1fV7LRYGSp1PbsD2TqUqdu8Wa', //RazeDefi
  'HPGvBemAvXBzdHkpxqSD3hMT5YCK4vrpt3ma4Q2jpzg3', //goup_neloy
  '7QPnq9MFDpcvJp9kUbG7E9PWYHDYbd7PqL5STghVd19V', //fharbz_web3
  'ECa6RGk9Auwh27eweJM5JNrqXiNJCytv6qZVD1N9NWvC', //Densemak
  'BdEk8urQ7xTp4oiTYpXBo7qRHdj8TNxxQr32V3rFRkm4', //grestionmax
  'BX3fMzbykR9ECjVYVSPACdkJDauDmJCH6KZmvCoBp1ZH', //mariosstanchev
  '8asx7SQZMs4eVBLZai8EPAid3159yA2SQyQjXs393Zvp', //DefiCaptainX
  '4dqhWf6FHrpcSQZXgbzSwNQT8um9KXKaqsdrTFUuBh1o', //OmegaOnChain
  '5KztNnBg6mHXErEimyPm6gqbbPqUwNCMCVZdoJd65ryo', //Sadiqjhussaini0
  'fq1fgcN6ce4C6dZ5mFTH2xyPhfenRkFPPbAcnRjdG2t', // Leenniiss
  'BpTvW7t9vi69siuBCTTN2AW29up1NBWZQQQ57LoQwEXX', //El_Samari74
  'GsZzHbGBcL3kqPbDeqwc1rmdTN1t5G2QkM62jussjR2R', //Georgekhimar
  'D4HPuGgCRNep55rXFoDbn6hJawRwH8WV3iaPnnwYM3HW', //hellerincrypto
  'ANYQsEAdAe88PpMoiTQBwRbjgcwvHP8kC3PyxYSEkxau', //trwdefistudent
  '7mgE74KtLnuJz8nFMeToakQT525gHdB3H3gXQqHDYa7U', //tonysolano777
  'EdSUPgteARjy1yPGdCDvehqWQ5zzxjvr5KkTHW1KXVkP', //anastasisbet
  'HKCk92AtBbJPkmUru1cVxkUaryQ8hZ643iMPLBEo6CU2', //MKVillanueva21
  '56CRgykvwrWcCyKY1L5UCc3NgCKz57ZE7AMJcP5tccCu', //second wallet of adrian
  'EiTT3KYhSV7YD9tKPdV4oAu9YaG7w2fwFQjdrNSfaMma', //IsmaelGuil14454
  'Gaae3bfKVQLRyyRpsiYtQN8WzuNYTBzojrwaGiQc4NGH', //CointelegraphAD
  'ExXF3MLUHQehgd6RYmV9vfBbUYpSN4ymGyToadfMjjCz', //aavseg
  'EJskXeX6f3g97Xo62nsgdr14RXRQ7Aa1fxmay6NiQgch', //Al_Qassam_70
  'BaH7WoMVZjqeYj1FqvmufpdKd4XH8At2f6ejPiqZJdsf', //DabidWm
  'wifGeXjYU7Hahgwq6VAnJJZBYqKM3aeymkrgnyMqkPQ',
  'H3YGXRuKbXsG8E9jt4YS6Zp29RBDUJPacFyhYQH88mdV',
  'mAGcbcVmwrJxGKQEE2At7RG8F43L8TUwiubDki2a8tv',
  'Eaw43KqioUiJmGCJgochfPcEdL2wfAUgjCz6tCR1Kpto',
  'Hkp5QHDYf8zVuWR1tx8cHMyZX8gwBHV8Q92epWMEPK1R',
  'GnWzYmW5SXrh9rohuE7M6HsJ4jBD3NrKpW4jsBVs1CKS',
  '8TV4bHeovauVAc5YzHFsxioxB6ep5e3MWKYJHtGjACwP',
  'Es5A4EBVSEtJs9U9RvbEHRd6S5Fjckw6qjVG86BFJBN7',
  'HMiTbvNEbm1PSuH4er4cKHXY53t9Y1fAoUTvjFjumLNc',
  '5ym1qCx17YvKvFNwuqZPcu1fkHhCgvJLptH3cVy2LjRy',
  'AzrgbrPT4EysUkgtQiSv686YyRQogKRuHDLc5fiyyYe8',
  '5pZPjJyTXTfsGohcYSeGBoQbi9sCDSa1AXuUwg1Y6SxR',
  'DSpMEXuJe2Nc9WehXJA5KakmvMxPdM5BvUn5ppWqkMrq',
  'C7m3kxzVUpcQrFnwkvpXwGSeNNYMzMoLVYPx5pBt9qH',
  'GaxVqiQyJKQDRu6H4pfy9V6Xq19pHGr6HQKDQDv911Y4',
  'BKDr1CDHyDq7efKC1wxtdh7CMhx8Mc4s3z8EJmr3m6it',
  '4jkhnYEm5nDUBGdqNcSzJkqRsujkSD5gBqVHQ1tbrCsX',
  '4Y78ixebsAARtmjgXNcRoFZC95v4mLVD1t6wTHuUWrYm',
  'FydnpdRPUMWWqo17sxrYmkyQ6QYDJX5QaJEwFJYX2tAK',
  'CF8XSGi7brutXE2T7jFqCqP7h2vhJrcjbNSAaUkFdqyx',
  '8Vp7BUcvDTWDqhyFH2GFEeye6Uoz4ew3TVj9jtQeTXFh',
  'DsE2L2WxtAAMLaBJPx3ddFxgKyyUmo4SmMmdUDP58Qhe',
  '6PKXJG5txnMoUeVzmh5VvSW5zy3SVBZuqtC2QeTLscZi',
  'FVMvVvkxhvfuv4Xj6Myw1jP7BKw65b66kv7ytqwTHUit',
  'HPp1ftgiDrw2AFfJBKNnes3FzfMf5urcjPcYcTRNHgcs',
  '65qqsruvPnTHr2NT2XuXzbS5vUdWN8Q5YiJF1jE8uwvF',
  'EkXB2n59PgxCpN8BRiKifNVdefoACgDdXzDrQLdSsmGb',
  'DPR3Bmg1wEZLJdPtiPNjxLu4MCUAVddYsrRNdPJMepjh',
  'DUWdETwzKGaxmkAxLcE11mfMkwP7J4hgJeFRz5z87w86',
  '3kFWxaBiysWLaFVJSuR1kAQ5Vj48nsj2spDsDddt5Xqk',
  'FvRb2Eav6q9R2huhJx9EkFFYWAJFVmUrSULY6XY7qqwT',
  'CZA3mWYZ14kZrPyPZHLUKEdvcjzQTetRgdoAJ3e8RvMd',
  'D5QbuBdpz24a83TPDn3qpww65zhnbqyVw9F7bwBKVw6P',
  '2kjgxGwx8DDaPU8uyiszrukK4XF9tQmppa49cudY2xtA',
  'HwQrks5kNtxqGg9ibjNaNRaUAzK92cFjCPLBFzEGaGu8',
  '7w2f4wuZZgANfrJhiNBYj7ee72Qv36Rg5ZBjJhSkhpvh',
  'H9ykVM72ne9rDjmfdu6CnbX38vfnNFBLijtQwEjL5VZj',
  '6cZTJgEaFGTVkoBYerA2sL43DffguACKhYKQD4XterR7',
  'DUMvm3uMNxrUhxAXte55eBgKWf4iR5Hdgza7VigiLrrh',
  'GZNWAQvxcYp5SEkBzEXDWvPUJ1dUtQAwGEFoXiny137c',
  '4AdEJqpWuojo5bpJL9W2pAfmF7tZwKEqLt5AW1AAKECr',
  '6WCsrkb6vg4zuWivq51peLyKjiTb1bsVkm43wVMZNF4F',
  'DBAeYy9AUQnS78CdSiRPbd5tLkq9eEAejDB8nEt4sRnQ',
  'qozyxgQ4m8heYqMiQESLxr6QJbzHfKutBQsAaTyCqm4',
  '9bEFeZMgMwEvPviKjX5Dc51XojZMECovqVaW3cxwJQ4B',
  '2FeXQQpPHgAx5inLZWib9gRMvZSkvvSBdJqQHvaLvXYh',
  'Hwg3BnJCuKRtmkBpPc4dj691SrQpLFebSSFoc4hyM9UU',
  '6KuK6k2Z8BH9xTmCAUiw2zMp93UWYjhiSSJwVV3CpUKr',
  'A1R2nnJVjGDQND5EkjEaaxfYBbSPsNUsN2c5Ws1pZn4V',
  'FRTMopr7HaMcUuEyRe8fjCS4eTN6wyGGUjtQBmhymkUe',
  'ABTgS9CaTfb4cWPc4gV2qGuGCFoFuSYGKf4qxAGg1tzk',
  '5UcC3N3BabXuw6zfSVtsJVS8o5WPqYcDJ2dtH5PZs8Ur',
  '465ajj5mg82zMMakHcikLKsk1jub8JJHe1ot7MjLdDw1',
  'HWz6dpFUZ3Ww7tt2bKMMR8sardg4DsyGi5iBDmiDbPaA',
  'AFSbpSpFrvfyTUSmRukw9ZLYKeh1UDbvpNUfJ3MnCL7g',
  'CH1NgoG8uq5A4ihJrCVpY6La8L8eCBouHjECdYGSf7Q',
  'AefLMaJrPUiB2h41M2rhTW3xfv4pTzY8f173EQA8DitP',
  'As2t1eGFY9VAeDe2DRdCtYprJ3MaW4Wg8dPCqHpTurCC',
  '3GLRJyfHFuaJzyWzvpTuiNqgs3JVmKWwRYJJ18o8QMsP',
  'GPRYPrJ18Zmcb8qSuxTL6gVwLNxnCGhtrpmaBjobCWRJ',
  '4BRMqdtjpvQccSVwDeCii4JmraLRJQc6eBbHWr7vhCPR',
  '3mH5SGQHEAtMgwikth3vmxR8F5hqhXUcZNs31RN2p8uC',
  '5YGRFqnSt13RZqBbRXExj6H4zZzwCw4WXNkKQ5obr2MA',
  'H5iSDfqA1hj3GykihjWkLHMZdzCmCJrhLDW2cvV6d1JV',
  '2BEv1BnmNFZKKN2VxUhAmwJDsW42FJm1i9toWUkodbVU',
  '9CPRc7TVeP3K9vGNvpVApDGsHMi6FyQyNtUBJ5QiDAZt',
  'EXUEGqDR2i7QzXLe7KkRVeGavcfeVR8x7Bw2qdy5QTeS',
  'GXsa84chHPFCBPBUSwb3GHzTQ5AoVYB78xSpb225eUK7',
  'eDckXK3FdvEpwrc2MgHBdcvYmkU2cNnuVx4aLZe4g8n',
]
